export const stripPhoneWhitespace = (value?: string | null): string => (value || '').replace(/\s+/g, '');

export const normalizePhoneCountryCode = (value?: string | null): string => {
  const cleaned = stripPhoneWhitespace(value);
  if (!cleaned) {
    return '';
  }
  return cleaned.startsWith('+') ? cleaned : `+${cleaned}`;
};

export const extractPhoneNumber = (value?: string | null, countryCode?: string | null): string => {
  const cleanedValue = stripPhoneWhitespace(value);
  const cleanedCode = normalizePhoneCountryCode(countryCode);
  if (cleanedCode && cleanedValue.startsWith(cleanedCode)) {
    return cleanedValue.slice(cleanedCode.length);
  }
  return cleanedValue.replace(/^\+/, '');
};
